import StickyHeader from './StickyHeader';

export default StickyHeader;
export * from './StickyHeader';
